/*
 *
 * Shops Actions
 *
 * @version 1.0.0
 * @author Giuseppe
 * @since 24-Jan-2023
 */

import { createRequestTypes, createAction, MakeRequest } from 'Store/actions/index';

export const actionTypes = {
	DO_SET_ITEM_TO_SHOW_DETAIL: '@@/set_item_to_show_detail',
	DO_RESET_ERROR: '@@/reset_error',
	// @generator action:route:type
	...createRequestTypes('@@Store', 'CREATE_STORE'),
	...createRequestTypes('@@Store', 'DELETE_STORE'),
	...createRequestTypes('@@Store', 'DETAIL_STORE'),
	...createRequestTypes('@@Store', 'UPDATE_STORE'),
	// @generator action:route:type:request
};

// ------------------------------------
// Actions
// ------------------------------------
// @generator action:route:request
/** @action request
 * * Insert a description
 * @name updateStore
 * @return {object} - The action object
 */
export const updateStore = new MakeRequest('Store', 'update_store');
/** @action request
 * * Insert a description
 * @name detailStore
 * @return {object} - The action object
 */
export const detailStore = new MakeRequest('Store', 'detail_store');
/** @action request
 * * Insert a description
 * @name deleteStore
 * @return {object} - The action object
 */
export const deleteStore = new MakeRequest('Store', 'delete_store');
/** @action request
 * * Insert a description
 * @name createStore
 * @return {object} - The action object
 */
export const createStore = new MakeRequest('Store', 'create_store');
// @generator action:route
/** @action
 * * Insert a description
 * @name ResetError
 * @return {object} - The payload object
 */
export const doResetError = (payload) => createAction(actionTypes.DO_RESET_ERROR, { payload });
/** @action
 * * Insert a description
 * @name SetItemToShowDetail
 * @return {object} - The payload object
 */
export const doSetItemToShowDetail = (payload) => createAction(actionTypes.DO_SET_ITEM_TO_SHOW_DETAIL, { payload });
